import React from 'react';
import Input from '../components/Input';
import Button from '../components/Button';
import Text from '../components/Text';
import Avatar from '../components/Avatar';
import { Link, useNavigate } from "react-router-dom";

function Scores(props) {
    return (
        <div className="w-home row w-fullscreen">
            <div className='col-lg-3 bg-blue w-half-left'>
                <Avatar
                    type="w-avatar-info"
                    nom="David"
                    mail="david.st@word.in"
                    worder="WOrder : 30"
                    src="/img/players/player_d.png"
                    classes="w-avatar-info"
                />
                <Link to="/home">
                    <Button text="Accueil" classes="w-btn-white" />
                </Link>
                <Link to="/partielettre">
                    <Button text="Nouvelle partie" classes="w-btn-white" />
                </Link>
                <Link to="/scores">
                    <Button text="Voir les scores" classes="w-btn w-btn-blue" />
                </Link>
                <Link to="/worders">
                    <Button text="Les WOrders (50)" classes="w-btn-white" />
                </Link>
                <Link to="/">
                    <Button text="Quitter" classes="w-text w-btn-gray" />
                </Link>
                <Link to="/aide">
                    <Text text="Besoin d'aide ?" classes="w-text-white-lg" />
                </Link>
            </div>
            <div className='col-lg-9 w-half-right'>

                <table class="table w-table">
                    <thead>
                        <tr>
                            <th scope="col">
                                <Text text="N°" classes="w-text-blue-m" />
                            </th>
                            <th scope="col">
                                <Text text="Partie" classes="w-text-blue-m" />
                            </th>
                            <th scope="col">
                                <Text text="Meilleurs score" classes="w-text-blue-m" />
                            </th>
                            <th scope="col">
                                <Text text="Classement" classes="w-text-blue-m" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="36445" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">

                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>

                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="36410" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">

                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>

                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="31410" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">

                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>

                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="30450" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">

                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>

                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="25121" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">

                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>

                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="22100" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>

                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="17504" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>

                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="16904" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>
                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="16904" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>
                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="16904" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>
                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="16904" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>
                        <tr className='w-row-white'>
                            <th scope="row">
                                <Text text="1" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="A00DF56D" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Text text="16904" classes="w-text-black-simple" />
                            </th>
                            <th scope="row">
                                <Link to="/scorespartie">
                                    <img className="w-img-xs" src="/img/categories/eye.png" alt="login" />
                                </Link>
                            </th>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Scores;